import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import { manualBetStore } from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';

export const AddNewSectionBtn = ({ t }) => {
  const createNewBetSection = () => {
    manualBetStore.openBetSection();
  };
  return (
    <>
      {isMobile() ? (
        <div className='create-new-btn-mob' onClick={createNewBetSection}>
          <div className='bet-inpt-rulers'>
            <span className=' ui-lib-plus' />
          </div>
        </div>
      ) : (
        <div className='crash-create-btn' onClick={createNewBetSection}>
          <div className='crash-create-btn-inside'>
            <p className='crash-create-btn-txt' title={t(globalTranslationKeys.CreateNew)}>
              {t(globalTranslationKeys.CreateNew)}
            </p>
            <div className='bet-inpt-rulers'>
              <span className=' ui-lib-plus' />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
